import script from "./AccordionBox.vue?vue&type=script&lang=ts"
export * from "./AccordionBox.vue?vue&type=script&lang=ts"

import "./AccordionBox.vue?vue&type=style&index=0&id=39ee0bdf&scoped=true&lang=css"

import exportComponent from "/home/runner/work/attack-flow/attack-flow/src/attack_flow_builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ee0bdf"]])

export default __exports__